import { httpGet } from '@pressreader/services';
import { toCamelCase } from '@pressreader/utils';

import { AnyParagraphDto } from '../types/paragraphs/any.paragrpah';

interface GetArticleContentRequest {
    articleId: number;
    lang?: string;
    injected?: boolean;
    isHyphenated?: boolean;
}

async function getArticleContent(request: GetArticleContentRequest) {
    const data: { lang?: string; injected?: boolean; isHyphenated?: boolean } = {};

    if (request.lang) {
        data.lang = request.lang;
    }

    if (request.injected) {
        data.injected = request.injected;
    }

    data.isHyphenated = request.isHyphenated === undefined ? true : request.isHyphenated;

    const content = await httpGet<AnyParagraphDto[]>(`v1/articles/${request.articleId}/content`, '', data);
    return toCamelCase(content);
}

export { getArticleContent };
